import type { Data } from '../../pages/best-companies/@dimension/+data.server';
import type { DimensionType } from '../../pages/best-companies/dimensionConfig';

function isRecord(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object';
}

/**
 * Full dimension payload (same shape as best-companies/@dimension +data) for client-side navigation.
 */
export async function fetchBestCompaniesDimensionFullFromApi(params: {
  slug: string;
  dimensionType: DimensionType;
  locale?: string;
  signal?: AbortSignal;
}): Promise<Data | null> {
  const slug = typeof params.slug === 'string' ? params.slug.trim() : '';
  if (!slug) return null;

  const q = new URLSearchParams({
    slug,
    type: params.dimensionType,
    full: '1',
    for: 'best-companies',
  });
  if (params.locale) q.set('locale', params.locale);

  try {
    const res = await fetch(`/api/best-companies-dimension?${q.toString()}`, {
      credentials: 'same-origin',
      headers: { accept: 'application/json' },
      signal: params.signal,
    });
    if (!res.ok) return null;
    const json: unknown = await res.json();
    if (!isRecord(json)) return null;
    if (json.config == null || typeof json.dimensionSlug !== 'string') return null;
    return json as Data;
  } catch {
    return null;
  }
}
